import { MouseEventHandler } from "react";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

type StockTickerArrowsProps = {
  direction: "left" | "right";
  onClick?: MouseEventHandler<SVGSVGElement> | undefined;
};

export default function StockTickerArrows({
  direction = "left",
  onClick,
}: StockTickerArrowsProps): React.ReactElement {
  return (
    <div
      className={cx("absolute top-1/2 hidden -translate-y-1/2 lg:block", {
        "right-0": direction === "right",
        "right-8": direction === "left",
      })}
    >
      <FontAwesomeIcon
        icon={direction === "left" ? faChevronLeft : faChevronRight}
        size="lg"
        className="block h-4 w-4 cursor-pointer rounded-full border border-black fill-gray-650 p-1 hover:opacity-100"
        onClick={onClick}
      />
    </div>
  );
}
